import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageSwiperStore from '../../components/swiper/page-swiper/store';
import { pageSwiperEffect } from '@src/components/swiper/page-swiper/config';
import { computed, observable } from 'mobx';
import { useEffect } from 'react';
import NaviBarStore from '@src/business-components/navibar/store';
import NegativeSectionStore from './sections/negative-section/store';
import FirstSectionStore from './sections/first-section/store';
import SecondSectionStore from './sections/second-section/store';
import CreatorsSectionStore from './sections/creators-section/store';
import ThirdSectionStore from './sections/third-section/store';
import FourSectionStore from './sections/four-section/store';
import FiveSectionStore from './sections/five-section/store';
import SixSectionStore from './sections/six-section/store';
import SevenSectionStore from './sections/seven-section/store';
import ComFooterStore from '@src/business-components/common-footer/store';
import cmsApi from '@src/services/cms-api';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import { dispatchCustomEvent } from '@src/utils/custom-event';

class MainStore extends BaseStore {
  //通用轮播
  pageSwiper = new PageSwiperStore({
    effectMode: pageSwiperEffect.FADE,
    onChangeFooterState: newState => this.onChangeFooterState(newState)
  });
  // 顶栏
  naviBarStore = new NaviBarStore({
    MainStore: this
  });
  globalStore = {};

  // 预热
  negativeSectionStore = new NegativeSectionStore({
    pageSwiperStore: this.pageSwiper
  });
  // 首页
  firstSectionStore = new FirstSectionStore({ mainStore: this });
  // 赛事
  secondSectionStore = new SecondSectionStore({});
  // 创作者招募
  creatorsSectionStore = new CreatorsSectionStore({});
  // 版本亮点
  thirdSectionStore = new ThirdSectionStore({});
  // 地图页
  fourSectionStore = new FourSectionStore({ mainStore: this });
  // 空投装备
  fiveSectionStore = new FiveSectionStore({});
  // 载具武装
  sixSectionStore = new SixSectionStore({});
  // 机兵
  sevenSectionStore = new SevenSectionStore({});

  // 底部版权栏
  comFooterStore = new ComFooterStore({
    scrollToTop: () => {
      this.pageSwiper.baseSwiperStore.onChange(0);
    }
  });

  // 是否显示顶部导航
  @observable isShowTopBar = true;

  // 0屏 预热页加载状态
  @observable negativeLoadstate = false;
  //第2屏加载状态
  @observable secondLoadState = false;
  //第3屏加载状态
  @observable thirdLoadState = false;
  //第4屏加载状态
  @observable fourLoadState = false;
  //第5屏加载状态
  @observable fiveLoadState = false;
  //第6屏加载状态
  @observable sixLoadState = false;
  //第7屏加载状态
  @observable sevenLoadState = false;
  //第8屏加载状态
  @observable eightLoadState = false;

  // 下载开放状态
  @observable download_status = null;

  // 是否第一次加载倒计时页面
  @observable isFirstLoadNegativeSection = true;
  // 是否开启赛事
  @observable isOpenCompetition = false;

  /**
   * 页面模块跟新切换-通知当前页面
   *  每个模块添加一个 isActive 变量
   * @param current
   */

  /**
   * 修改footer的显隐状态
   * @param newState
   */
  onChangeFooterState = newState => {
    this.comFooterStore.isActive = newState;
  };
  @computed
  get pageStore() {
    return [
      // this.negativeSectionStore,
      this.firstSectionStore,
      ...(this.isOpenCompetition ? [this.secondSectionStore] : []), // 根据 isOpenCompetition 动态决定是否加入 secondSectionStore
      this.thirdSectionStore,
      this.fourSectionStore,
      this.fiveSectionStore,
      this.sixSectionStore,
      this.sevenSectionStore
    ];
  }
  changePageVisible(current) {
    this.pageStore.map((item, index) => {
      item.isActive = current === index;
    });
  }
  initLoadingTimeout = () => {
    const baseDelayTIme = 3000;
    clearTimeout(this.secondLoadTimer);
    clearTimeout(this.secondLoadTimer);
    clearTimeout(this.thirdLoadTimer);
    clearTimeout(this.fourLoadTimer);
    // 预热页+第二屏
    this.secondLoadTimer = setTimeout(() => {
      this.secondLoadState = true;
      this.negativeLoadstate = true;
      clearTimeout(this.secondLoadTimer);
    }, baseDelayTIme);

    // 第三屏 baseDelayTIme+1秒后开始加载
    this.secondLoadTimer = setTimeout(() => {
      this.thirdLoadState = true;
      clearTimeout(this.secondLoadTimer);
    }, baseDelayTIme + 1000);
    // 第四屏 baseDelayTIme+2秒后开始加载
    this.thirdLoadTimer = setTimeout(() => {
      this.fourLoadState = true;
      clearTimeout(this.thirdLoadTimer);
    }, baseDelayTIme + 2000);
    // 第五屏 baseDelayTIme+3秒后开始加载
    this.fourLoadTimer = setTimeout(() => {
      this.fiveLoadState = true;
      clearTimeout(this.fourLoadTimer);
    }, baseDelayTIme + 3000);
    // 第六屏 baseDelayTIme+4秒后开始加载
    this.fiveLoadTimer = setTimeout(() => {
      this.sixLoadState = true;
      clearTimeout(this.fiveLoadTimer);
    }, baseDelayTIme + 4000);
    // 第七屏 baseDelayTIme+5秒后开始加载
    this.sixLoadTimer = setTimeout(() => {
      this.sevenLoadState = true;
      clearTimeout(this.sixLoadTimer);
    }, baseDelayTIme + 5000);
  };

  // // 预约请求发送
  // downloadStatusAsync = () => {
  //   return this.$ztService.downloadStatus();
  // };

  // https://www.mechabreak.com/api/config/tag/zt/msmk_page_config?filter=0
  getMsmkPageConfig = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/msmk_page_config?filter=0')
      .then(res => {
        // console.log(res);
        // en_news_url
        // this.isOpenCompetition = !!+res?.competition_state;
        // this.topBarStore.isOpenCompetition = !!+res?.competition_state;
        // this.isOpenCompetition = this.topBarStore.isOpenCompetition = false;
        let newsUrl = getLanguageByPath() === 'zh-Hant' ? 'tc_news_url' : getLanguageByPath() + '_news_url';
        let competition_url = getLanguageByPath() === 'zh-Hant' ? 'tc_competition_url' : getLanguageByPath() + '_competition_url';
        // steam_url
        let steam_url = getLanguageByPath() === 'zh-Hant' ? 'tc_steam_url' : getLanguageByPath() + '_steam_url';
        // xbox_url
        let xbox_url = getLanguageByPath() === 'zh-Hant' ? 'tc_xbox_url' : getLanguageByPath() + '_xbox_url';

        // this.topBarStore.newsUrl = res[newsUrl];
        this.secondSectionStore.competition_url = res[competition_url];
        this.firstSectionStore.steam_link1 = res[steam_url];
        this.firstSectionStore.xbox_link1 = res[xbox_url];
      })
      .catch(e => {
        console.log(e);
      });
  };

  use() {
    super.use();

    // this.downloadStatus = useRequest(async () => await this.downloadStatusAsync(), {
    //   manual: false,
    //   onSuccess: data => {
    //     this.firstSectionStore.isDownLoadTime = data.download_status;
    //     this.download_status = data.download_status;
    //   },
    //   onError: e => {
    //     console.log(e);
    //   }
    // });
    useEffect(
      () => {
        if (this.naviBarStore.selectStore.isOpen === false && this.comFooterStore.selectStore.isOpen === false) {
          this.pageSwiper.isScrollEnabled = true;
        } else {
          this.pageSwiper.isScrollEnabled = false;
        }
      },
      [this.naviBarStore.selectStore.isOpen, this.comFooterStore.selectStore.isOpen]
    );
    //默认开始加载第二屏
    useEffect(() => {
      // TODO TEST
      this.pageSwiper.baseSwiperStore.onChange(0);
    }, []);

    useMount(() => {
      this.initLoadingTimeout();
      this.getMsmkPageConfig();

      //重写to_top_handler
      window.OMNI__COMMON__FOOTER.to_top_handler = () => {
        this.pageSwiper.baseSwiperStore.onChange(0);
      };
      //coookie_settings
      window.OMNI__COMMON__FOOTER.coookie_settings = function() {
        // 触发自定义事件，通知cookie-tips组件
        dispatchCustomEvent('omni:footer:cookie_settings');
      };
      //当前选择语言
      window.OMNI__COMMON__FOOTER.currentLanguageCode = getLanguageByPath();
      //初始化
      window.init_OMNI__COMMON__FOOTER();
    });

    useEffect(
      () => {
        if (this.pageSwiper.baseSwiperStore.activeIndex === 0) {
          this.naviBarStore.isSticky = false;
        } else {
          this.naviBarStore.isSticky = true;
        }
        // this.isShowTopBar = this.pageSwiper.baseSwiperStore.activeIndex > 0;
        if (this.isFirstLoadNegativeSection && this.pageSwiper.baseSwiperStore.activeIndex === 0) {
          this.isFirstLoadNegativeSection = false;
        }
        this.changePageVisible(this.pageSwiper.baseSwiperStore.activeIndex);
        this.naviBarStore.currentIndex = this.pageSwiper.baseSwiperStore.activeIndex;
      },
      [this.pageSwiper.baseSwiperStore.activeIndex]
    );
  }
}

export default MainStore;
